import React from 'react';
function getExpirationDate(): string {
  const now = new Date();
  const expDate = new Date(now.getTime() + 3 * 24 * 60 * 60 * 1000);
  const months = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  const day = expDate.getDate();
  const month = months[expDate.getMonth()];
  return `${day} de ${month}`;
}
export function UrgencyBanner() {
  const expirationDate = getExpirationDate();
  return <div className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-red-600 via-red-500 to-red-600 text-white text-center py-2.5 px-4 shadow-lg" data-id="element-310">
      <p className="text-sm md:text-base font-bold tracking-wide flex items-center justify-center gap-2 flex-wrap" data-id="element-311">
        <span className="animate-pulse" data-id="element-312">🔥</span>
        <span data-id="element-313">Oferta de Re-Lanzamiento</span>
        <span className="hidden sm:inline" data-id="element-314">—</span>
        <span className="text-yellow font-extrabold" data-id="element-315">
          expira el {expirationDate}
        </span>
        <span className="animate-pulse" data-id="element-316">🔥</span>
      </p>
    </div>;
}